export default __webpack_public_path__ + "static/media/next-icon.374ac251.svg";